/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vast_Fast_Swan_NestInputs */

const en_vast_fast_swan_nest = /** @type {(inputs: Vast_Fast_Swan_NestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to save`)
};

const de_vast_fast_swan_nest = /** @type {(inputs: Vast_Fast_Swan_NestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler beim Speichern`)
};

/**
* | output |
* | --- |
* | "Failed to save" |
*
* @param {Vast_Fast_Swan_NestInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const vast_fast_swan_nest = /** @type {((inputs?: Vast_Fast_Swan_NestInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vast_Fast_Swan_NestInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vast_fast_swan_nest(inputs)
	return de_vast_fast_swan_nest(inputs)
});